module.exports = __webpack_public_path__ + "media/images/svg-icon/horizontal-226f0b86d3066df53acbe87ef7f317a1.svg";